import { EApiLanguageCode } from '@datatype/iyagigo/api-type';
/** @jsxImportSource @emotion/react */

import React from 'react';
import PageTemplate from '@page/iyagigo/page-template';
import Scroll from '@component/common/scroll';
import VocabularyBookHome from '@component/iyagigo/vocabulary-book/vocabulary-book-home';
import * as color from '@constant/color';
import { useTypedSelector } from '@hook/common/useStore';

const VocabularyBookHomePage: React.FC<any> = () => {
  const studyLanguage = useTypedSelector((state) => state.rootReducer?.studentReducer?.currentStudyLanguage) ?? null;
  const HEADER_TITLE = `${studyLanguage === EApiLanguageCode.ENGLISH ? '영어' : '일본어'} 단어집`;

  return (
    <PageTemplate title={HEADER_TITLE} mode={'page'} backgroundColor={color.GRAY_BACKGROUND_COLOR}>
      <Scroll direction='y' height={`calc(100% - 10px)`}>
        <VocabularyBookHome />
      </Scroll>
    </PageTemplate>
  );
};

export default VocabularyBookHomePage;
